'use client';

import Image from 'next/image';
import Link from 'next/link';

import Container from '@/components/layouts/container';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className='min-h-screen bg-brand-light'>
      <Container className='flex min-h-screen flex-col items-center justify-center py-10'>
        <Link href='/' className='mb-8 flex items-center gap-1'>
          <Image
            src='/logos/skill4skill-logo-icon.svg'
            alt='Skill4Skill Logo'
            width={48}
            height={48}
            style={{ height: '48px', width: '48px' }}
            className='h-12 w-auto'
            priority={true}
          />
          <span className='ml-2 text-xl font-bold text-brand-base'>
            Skill4Skill
          </span>
        </Link>

        <div className='w-full max-w-lg rounded-lg bg-white p-8 text-center shadow-sm'>
          <h1 className='mb-4 font-young text-2xl text-brand-dark'>
            Page Not Found
          </h1>
          <p className='mb-6 text-gray-600'>
            The page you are looking for doesn&apos;t exist or has been moved.
          </p>

          <div className='flex justify-center'>
            <Button variant='secondary' asChild>
              <Link href='/'>Return home</Link>
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
